import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import ReactToPrint from "react-to-print";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import { Document, Page, pdfjs, Thumbnail } from "react-pdf";
import { useTheme, styled } from "@mui/material/styles";
import { ButtonGroup } from "@mui/material";
import { receiptImageStyle } from "../Constant";
import { replaceImageSource } from "../../helpers/withReplaceImageSource";
import { useRecordContext } from "react-admin";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
}));

const LargeAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(7),
  height: theme.spacing(7),
}));

class ComponentToPrint extends React.Component {
  render() {
    return <div>{this.props.children}</div>;
  }
}

const ImageReceipt = ({ fileUrl }) => {
  const componentRef = useRef();
  const [rotation, setRotation] = useState(0);
  const [scaleX, setScaleX] = useState(1);
  const [scaleY, setScaleY] = useState(1);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <div onClick={handleOpen}>
        <LargeAvatar variant="square" alt="receipt" src={fileUrl} />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Receipt</DialogTitle>
        <DialogContent>
          <ComponentToPrint ref={componentRef}>
            <img
              style={{
                ...receiptImageStyle,
                transform: `rotate(${rotation}deg) scaleX(${scaleX}) scaleY(${scaleY})`,
              }}
              alt="receipt"
              src={fileUrl}
            />
          </ComponentToPrint>
        </DialogContent>
        <DialogActions>
          <ButtonGroup variant="outlined" aria-label="image tools">
            <Button color="primary" onClick={() => setRotation(rotation + 90)}>
              Rotate
            </Button>
            <Button onClick={() => setScaleX((prev) => prev * -1)}>
              Flip X
            </Button>
            <Button onClick={() => setScaleY((prev) => prev * -1)}>
              Flip Y
            </Button>
          </ButtonGroup>
          <ReactToPrint
            trigger={() => (
              <IconButton aria-label="print">
                <PrintIcon />
              </IconButton>
            )}
            content={() => componentRef.current}
          />
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const Pdf = ({ fileUrl: oriFileUrl }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const fileUrl = replaceImageSource(oriFileUrl);
  const componentRef = useRef();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div onClick={handleOpen}>
        <Document file={fileUrl}>
          <Thumbnail scale={0.2} pageNumber={1} />
        </Document>
      </div>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Receipt</DialogTitle>
        <DialogContent>
          <ComponentToPrint ref={componentRef}>
            <Document file={fileUrl}>
              <Page pageNumber={1} />
            </Document>
          </ComponentToPrint>
        </DialogContent>
        <DialogActions>
          <ReactToPrint
            trigger={() => (
              <IconButton aria-label="print">
                <PrintIcon />
              </IconButton>
            )}
            content={() => componentRef.current}
          />
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const Receipt = () => {
  const record = useRecordContext();
  const fileUrl = (record && record.receipt && record.receipt.fileUrl) || "";
  const isPdf = fileUrl.toLowerCase().indexOf(".pdf") > -1;
  const newFileUrl = replaceImageSource(fileUrl);
  return isPdf ? (
    <Pdf fileUrl={newFileUrl} />
  ) : (
    <ImageReceipt fileUrl={newFileUrl} />
  );
};

export default Receipt;
